import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators {
    public static conditionalValidator(predicate, validator: ValidatorFn) {
        return formControl => {
            if (!formControl.parent) {
                return null;
            }
            if (predicate(formControl)) {
                return validator(formControl);
            }
            return null;
        };
    }

    public static atLeastOneOfAll(validator: ValidatorFn): ValidatorFn {
        return (currentGroup: AbstractControl) => {
            const tempCurrentGroup = currentGroup as UntypedFormGroup;
            const hasAtLeastOne =
                tempCurrentGroup?.controls &&
                Object.keys(tempCurrentGroup.controls).some(key => !validator(tempCurrentGroup.get(key) as AbstractControl));

            return hasAtLeastOne ? null : { atLeastOne: true };
        };
    }

    public static noWhitespaceValidator(control: UntypedFormControl): ValidationErrors | null {
        let isWhitespace = false;
        if (control?.value?.toString()) {
            isWhitespace = control.value.toString().trim().length === 0;
        }
        return isWhitespace ? { whitespace: true } : null;
    }

    public static noDefaultDropdownOption(defaultValue: string): ValidatorFn {
        return (control: AbstractControl) => {
            const controlValue = control?.value?.toString();
            return controlValue === defaultValue ? { defaultDropdownValue: true } : null;
        };
    }

    public static minTrimmedLengthValidator(minLength: number): ValidatorFn {
        return (control: AbstractControl) => {
            const controlValue = control?.value?.toString();
            if (!controlValue || controlValue.length === 0) {
                return null;
            }

            return controlValue.trim().length < minLength ? { minTrimmedLength: true } : null;
        };
    }
}
